import React, { useContext } from 'react';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, message, Modal, Space, Tooltip } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { UserContext } from '../../../../repository/context/userContext';
import { btnActive } from '../../../../styles';
import { GRAPHICS } from '../../../../constants/define/translation';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { deleteTextRepository } from '../../../../repository/mytm/text/textRepository';

interface TextActionsColumnProps {
  record: any;
  onRefresh?: (loading?: boolean) => void;
  onLoading: (loading: boolean) => void;
  onHandleClickBtnEdit: (record: any) => void;
}
export default React.memo((props: TextActionsColumnProps) => {
  const { t } = useTranslation(GRAPHICS);
  const { record, onRefresh, onLoading, onHandleClickBtnEdit } = props;
  const userContext = useContext(UserContext);

  const onHandleDelete = async (options: any) => {
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('popup.deleteText')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        onLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        const onFunc = () => {
          deleteTextRepository(record.id)
            .then(() => {
              onRefresh && onRefresh(true);
              message.success(t('message.deleteText'));
              onLoading(false);
            })
            .catch(error => {
              message.error(error.message);
              onLoading(false);
            });
        };

        if (!userContext.user?.email || userContext.user?.email === '') {
          message.error(MESSAGE_ERROR.M02);
          onLoading(false);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              onFunc();
            })
            .catch((e: any) => {
              onLoading(false);
              message.error(e?.errorMessage);
            });
        }
      },
    });
  };

  const onHandleClickBtnEditText = () => {
    onHandleClickBtnEdit(record);
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={t('table.action.edit')}>
          <Button icon={<EditOutlined />} onClick={onHandleClickBtnEditText} />
        </Tooltip>
        <Tooltip title={t('table.action.delete')}>
          <Button icon={<DeleteOutlined />} onClick={onHandleDelete} />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 0.5rem;
  ${btnActive}
  button {
    cursor: pointer;
  }
`;
